import React, { useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import { Divider, Grid, IconButton, TextField, Tooltip } from '@mui/material';
import DialogActions from '@mui/material/DialogActions';
import DialogTitle from '@mui/material/DialogTitle';
import RemoveCircleIcon from '@mui/icons-material/RemoveCircle';

import { Button, SubmitButton } from '../../../../../common/button';
import { deleteCustomerBlockadeRegistryNotificationData, getCustomerNotificationData } from '../../../../../../core/utils/notification_utils';
import { ApiRequestStatusEnum } from '../../../../../../core/enums/common/api';
import useNotification from '../../../../../../core/hooks/use_notification';
import { deleteCustomerBlockadeRegistryAction, deleteCustomerBlockadeRegistryState } from '../../../../../../features/customer/delete_customer_blockade_registry';
import { getCustomerAction } from '../../../../../../features/customer/get_customer';

const DeleteCustomerBlockadeRegistryDialog = ({ id, customerId }) => {
    const dispatch = useDispatch();
    const { showNotification, showErrorMessage } = useNotification();
    const liftingReasonRef = useRef(null);

    const deleteCustomerBlockadeRegistry = useSelector(deleteCustomerBlockadeRegistryState);

    const [open, setOpen] = useState(false);

    const onClose = () => setOpen(false);

    const onRemoveCustomerBlockadeRegistry = () => {
        dispatch(deleteCustomerBlockadeRegistryAction({ id, liftingReason: liftingReasonRef?.current?.value }))
            .then(response => {
                showNotification(deleteCustomerBlockadeRegistryNotificationData(response));

                if (response?.meta?.requestStatus === ApiRequestStatusEnum.FULFILLED) {
                    dispatch(getCustomerAction(customerId))
                        .then(response => showErrorMessage(getCustomerNotificationData(response)));
                    onClose();
                }
            });
    };

    return (
        <>
            <Tooltip title="Znieś blokadę">
                <IconButton size="small" onClick={ () => setOpen(true) }>
                    <RemoveCircleIcon/>
                </IconButton>
            </Tooltip>

            <Dialog PaperProps={ { sx: { maxHeight: 800 } } } open={ open } onClose={ onClose } fullWidth maxWidth="sm">
                <DialogTitle sx={ { fontWeight: 600, pb: 1 } }>Znieś blokadę</DialogTitle>

                <Divider/>

                <DialogContent sx={ { py: 3 } }>
                    <Grid container spacing={ 3 }>
                        <Grid item xs={ 12 }>
                            <TextField
                                name="liftingReason"
                                label="Powód zniesienia blokady"
                                fullWidth
                                size="small"
                                inputRef={ liftingReasonRef }
                                required
                            />
                        </Grid>
                    </Grid>
                </DialogContent>

                <Divider sx={ { mt: 1 } }/>

                <DialogActions sx={ { px: 3, py: 2, gap: 1 } }>
                    <Button variant="outlined" onClick={ onClose }>Zamknij</Button>
                    <SubmitButton onClick={ onRemoveCustomerBlockadeRegistry } isLoading={ deleteCustomerBlockadeRegistry?.loading }>Zapisz</SubmitButton>
                </DialogActions>
            </Dialog>
        </>
    );
};

export default DeleteCustomerBlockadeRegistryDialog;